<!-- STRT FOOTER -->
<section class="section footer" style="padding-bottom: 0px;">
    <!-- <div class="bg-overlay"></div> -->
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="text-center">
                    <ul class="list-inline social mb-0">
                        <li class="list-inline-item"><img width="170px" src="./assets/images/logos-02.png" alt=""></li>
                        <li class="list-inline-item"><img width="170px" src="./assets/images/logotipo.png" alt=""></li>
                        
                    </ul>
                </div>
                <!-- <div class="footer-terms">
                    <ul class="mb-0 list-inline text-center mt-4 pt-2">
                        <li class="list-inline-item"><a href="javascript:void(0);" class="text-muted">Terms & Condition</a></li>
                        <li class="list-inline-item"><a href="javascript:void(0);" class="text-muted">Privacy Policy</a></li>
                        <li class="list-inline-item"><a href="javascript:void(0);" class="text-muted">Contact Us</a></li>
                    </ul>
                </div> -->
                <div class="mt-4 pt-2 text-center">
                    <p class="copy-rights text-muted mb-0">
                       {{year}} © Universidad San Gregorio de Portoviejo
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- END FOOTER -->